export type ContentRefreshScope = 'home' | 'list'

export interface ContentRefreshPolicy {
  staleAfterMs: number
  pollIntervalMs: number
  minRefreshGapMs: number
  maxFailureBackoffMs: number
}

const ONE_MINUTE_MS = 60 * 1000

// Shared freshness defaults so all sections behave consistently.
const BASE_POLICY: ContentRefreshPolicy = {
  staleAfterMs: 5 * ONE_MINUTE_MS,
  pollIntervalMs: 15 * ONE_MINUTE_MS,
  minRefreshGapMs: ONE_MINUTE_MS,
  maxFailureBackoffMs: 10 * ONE_MINUTE_MS,
}

const LIST_POLICY: ContentRefreshPolicy = {
  staleAfterMs: BASE_POLICY.staleAfterMs,
  pollIntervalMs: BASE_POLICY.pollIntervalMs,
  minRefreshGapMs: BASE_POLICY.minRefreshGapMs,
  maxFailureBackoffMs: BASE_POLICY.maxFailureBackoffMs,
}

export function getContentRefreshPolicy(scope: ContentRefreshScope): ContentRefreshPolicy {
  if (scope === 'list') {
    return LIST_POLICY
  }
  return BASE_POLICY
}

